export { default as NtiLink } from "./NtiLink";
